import { Badge, Spinner } from "@chakra-ui/react";
import { useEffect } from "react";
import { useVehicle } from "../../contexts/VehicleContext";
import { useCheckFitmentMutation } from "../Api/fitmentApi";

interface Props {
    partId: string;
}

export default function FitmentBadge({ partId }: Props) {
    const { vehicle } = useVehicle();

    const [
        checkFitment,
        { data, isLoading, isError },
    ] = useCheckFitmentMutation();

    useEffect(() => {
        if (!vehicle || !partId) return;

        checkFitment({
            partId,
            vehicle,
        });
    }, [partId, vehicle, checkFitment]);

    // No vehicle selected → no badge
    if (!vehicle) return null;

    // Loading state
    if (isLoading) {
        return <Spinner size="xs" mt={2} />;
    }

    // Error → assume does not fit (safe default)
    if (isError || !data) {
        return (
            <Badge colorScheme="red" mt={2}>
                Fitment unknown
            </Badge>
        );
    }

    return data.fits ? (
        <Badge colorScheme="green" mt={2}>
            Fits your vehicle
        </Badge>
    ) : (
        <Badge colorScheme="red" mt={2}>
            Does not fit your vehicle
        </Badge>
    );
}
